import { navigate } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';

import ContentfulImage from '../Common/ContentfulImage';
import { ArrowLink } from '../Common/Links';
import PageSection from '../Common/PageSection';
import RichTextConverter from '../Common/RichText/RichTextConverter';
import * as styles from './LargeCards.module.css';

export const LargeCard = ({
  imageFragment,
  type,
  title,
  description,
  url,
  ctaLabel,
  backgroundColor,
  fullImage = false,
  ...rest
}) => {
  const onCard = (e) => {
    e.preventDefault();
    if (typeof window === 'undefined') return;
    navigate(url);
  };
  return (
    /*eslint-disable-next-line */
    <div
      className={[styles.postCard, url ? styles.postCardLink : '', styles[backgroundColor]].join(' ')}
      onClick={url ? onCard : null}
      {...rest}
    >
      <div className={[styles.cardImage, fullImage ? styles.fullImage : ''].join(' ')}>
        <ContentfulImage imageFragment={imageFragment} />
      </div>
      {type && <div className={styles.cardType}>{type}</div>}
      <h4>{title}</h4>
      {typeof description === 'string' ? <p>{description}</p> : description}
      {url && ctaLabel && (
        <div className={styles.postLink}>
          <ArrowLink label={ctaLabel} url={url} />
        </div>
      )}
    </div>
  );
};

const LargeCards = ({ section, className, noPad = false, fullImage = false, wide = false }) => {
  const hasCTA = section.content.filter((c) => !!c.linkUrl).length > 0;
  const cards = section.content
    .filter((c) => c.__typename === 'ContentfulSimpleCard')
    .map((card, i) => {
      const text = card.body?.raw ? <RichTextConverter copy={card.body} /> : '';
      return (
        <LargeCard
          fullImage={fullImage}
          key={i}
          imageFragment={card.image}
          url={card.linkUrl}
          ctaLabel={card.linkLabel}
          title={card.title}
          description={text}
          type={card.subtitle}
          backgroundColor={card.accentColor}
        />
      );
    });

  const columns = { '--column-count': section.itemsPerRow || 3 };

  return (
    <PageSection slim wide={wide} className={className}>
      <div className={wide ? styles.container : ''}>
        {section.headingSize === 'H3' && <h3>{section.heading}</h3>}
        {section.headingSize !== 'H3' && <h2>{section.heading}</h2>}
        {section.sectionCopy && <RichTextConverter className={styles.shortText} copy={section.sectionCopy} />}
        <div style={columns} className={[styles.grid, noPad && !hasCTA ? '' : styles.pad].join(' ')}>
          {cards}
        </div>
      </div>
    </PageSection>
  );
};

LargeCards.propTypes = {
  section: PropTypes.object.isRequired,
  className: PropTypes.string,
};

export default LargeCards;
